import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router";
import logo from "./logo.svg";
import "./App.css";
import Login from "./Pages/login";
import { RecorderPage } from "./Pages/recorder";
import { Dashboard } from "./Pages/dashboard";
import { ClerkProvider } from "@clerk/clerk-react";
import {
  clerkPublishableKey,
  REACT_APP_PUBLIC_POSTHOG_HOST,
  REACT_APP_PUBLIC_POSTHOG_KEY,
} from "./env";
import { RegisterOrg } from "./Pages/RegisterOrg";
import { PaymentPage } from "./Pages/payment";
// import { PaymentCompletePage } from "./Pages/paymentComplete";
import { PlanChoicePage } from "./Pages/planchoice";
import { PostHogProvider } from "posthog-js/react";
import posthog from "posthog-js";
import { isProd } from "./isProd";
import { SharedLinkPage } from "./Pages/sharedlink";
import { Tutoral } from "./Pages/tutorial";
import { AuthWrapper } from "./AuthWrapper";
import { RedirectToDashboard } from "./Pages/redirectToDashboard";

const options = {
  api_host: REACT_APP_PUBLIC_POSTHOG_HOST,
  ui_host: "https://us.posthog.com",
};

const key = isProd ? REACT_APP_PUBLIC_POSTHOG_KEY : "";

function App() {
  return (
    <>
      <title>Speaking of Me</title>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap"
        rel="stylesheet"
      />
      <PostHogProvider apiKey={key} options={options}>
        <Router>
          <div>
            <ClerkProvider
              publishableKey={clerkPublishableKey}
              afterSignOutUrl="/"
              appearance={{ layout: { logoImageUrl: "/logo.svg" } }}
            >
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/signup" element={<Login />} />
                <Route path="/sign-up" element={<Login />} />
                <Route path="/signup/:specialCode" element={<Login />} />
                <Route path="/c/:id" element={<RecorderPage />} />

                <Route path={"/plans"} element={<PlanChoicePage />} />
                <Route
                  path={"/shared/:reviewHash"}
                  element={<SharedLinkPage />}
                />
                <Route path={"/auth"} element={<AuthWrapper />}>
                  <Route path="dashboard/tutorial" element={<Tutoral />} />

                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="set-up/:specialCode" element={<RegisterOrg />} />
                  <Route
                    path="pricing/:type/:period"
                    element={<PaymentPage />}
                  />

                  <Route path="set-up" element={<RegisterOrg />} />
                </Route>
                <Route path="*" element={<RedirectToDashboard/>} />
              </Routes>
            </ClerkProvider>
          </div>
        </Router>
      </PostHogProvider>
    </>
  );
}

export default App;
